import { useNavigate } from "react-router-dom";

const BasicLayout = ({
    title,
    subtitle,
    titleTwo,
    subtitleTwo,
    titleThree,
    subtitleThree,
    content,
    backButtonRoute,
}) => {
    const navigate = useNavigate();

    return (
        <div className="relative flex flex-col gap-6">
            <div className="flex items-center justify-between">
                <div className="flex flex-col gap-1">
                    <h2 className="text-2xl font-bold text-gray-800 dark:text-white">
                        {title}
                    </h2>

                    <p className="text-[14.5px] text-gray-700/80 dark:text-white">
                        {subtitle}
                    </p>
                </div>

                {backButtonRoute && (
                    <button
                        type="button"
                        onClick={() => {
                            navigate(backButtonRoute);
                        }}
                        className="linear bg-transparent rounded-[8px] border border-brand-500 px-[10px] py-[4px] text-sm font-bold uppercase text-brand-500 transition duration-200 ms-4 hover:bg-brand-600 hover:text-white active:bg-brand-700 active:text-white dark:bg-brand-400 dark:text-brand-500 dark:hover:bg-brand-300 dark:hover:text-white dark:active:bg-brand-200 dark:active:text-white"
                    >
                        Indietro
                    </button>
                )}
            </div>

            {(titleTwo || subtitleTwo) && (
                <div className="flex flex-col gap-1">
                    <h2 className="text-2xl font-bold text-gray-800 dark:text-white">
                        {titleTwo}
                    </h2>

                    <p className="text-[14.5px] text-gray-800 dark:text-white">
                        {subtitleTwo}
                    </p>
                </div>
            )}

            {(titleThree || subtitleThree) && (
                <div className="flex flex-col gap-1">
                    <h2 className="text-2xl font-bold text-gray-800 dark:text-white">
                        {titleThree}
                    </h2>

                    <p className="text-[14.5px] text-gray-800 dark:text-white">
                        {subtitleThree}
                    </p>
                </div>
            )}

            {content}
        </div>
    );
};

export default BasicLayout;
